

import { useEffect, useRef } from 'react';
// import { connect } from "react-redux";
import { useInstrumentsDynamic } from '@/controllers/gridManager/PriceboardManager';
import { find, includes, isEqual, map } from 'lodash';

function getPropertysChanged(oldItem: any, item: any) {
    let _item: any = {}
    map(Object.keys(item), (key: any) => {
        if (item[key] != oldItem[key]) {
            _item[key] = item[key];
        }
    })
    let _arrKeys = Object.keys(_item)
    let isCheckEx = includes(_arrKeys, "RE") || includes(_arrKeys, "CL") || includes(_arrKeys, "FL")
    if (isCheckEx) {
        // return all dữ liệu khi RE, CL
        // console.debug("getPropertysChanged.:", isCheckEx, _arrKeys)
        let _itemEx: any = {}
        map(Object.keys(item), (key: any) => {
            if (item[key] != oldItem[key]) {
                _itemEx[key] = item[key];
            } else {
                if (item[key] != undefined && item[key] != null) {
                    // Bỏ qua trường hợp key không thay đổi và giá trị key không hiển thị thì không cần highlight lại
                    if (key == "CH" || key == "percent") {
                        _itemEx[key] = item[key];
                    } else {
                        if (item[key] != 0 && item[key] != "0") {
                            _itemEx[key] = item[key];
                        }
                    }
                }
            }
        })
        _itemEx.force = true // add highlight all khi RE/CL/FL thay đổi
        return _itemEx;
    }
    return _item;
}

const RenderGridCellRealTimePriceBoard = (props: { symbol: string, idTablePb: string, applyTransactionAsyncRealtime: any }) => {
    const { instrumentsDynamic } = useInstrumentsDynamic() as any
    const prevStateInstrumentsDynamic = useRef(find(instrumentsDynamic, (e) => e.SB == props?.symbol))
    useEffect(() => {
        // const { instrument } = nextProps;
        // const { instrument: prevInstrument } = this.props;
        // if ()

        let instrument = find(instrumentsDynamic, (e) => e.SB == props?.symbol)
        // console.log("RenderGridCellRealTimePriceBoard.:msg.:i_1.:RenderGridCell.:AsyncRealtime.:", { symbol: props?.symbol, instrument, prevStateInstrumentsDynamic: prevStateInstrumentsDynamic.current })
        if (!prevStateInstrumentsDynamic.current) {
            if (props.applyTransactionAsyncRealtime) {
                // console.log("RenderGridCellRealTimePriceBoard.:msg.:i_2.:RenderGridCell.:AsyncRealtime.:", { obj: { instrument } })
                props.applyTransactionAsyncRealtime({ instrument }, props.idTablePb)
                prevStateInstrumentsDynamic.current = instrument;
            }
            return () => { }
        }

        // console.log("RenderGridCellRealTimePriceBoard.:msg.:i_check.:RenderGridCell.:AsyncRealtime.:", { s1:prevStateInstrumentsDynamic.current?.SB, s2: instrument.SB })
        if (instrument && (instrument.SB == prevStateInstrumentsDynamic.current?.SB) && (!(isEqual(instrument, prevStateInstrumentsDynamic.current)))) {
            // console.log("RenderGridCellRealTimePriceBoard.:msg.:i_3.:RenderGridCell.:AsyncRealtime.:", { obj: { instrument } })
            let _instrument = getPropertysChanged(prevStateInstrumentsDynamic.current, instrument)
            _instrument.SB = instrument.SB
            _instrument.bySocketUpdate = instrument.bySocketUpdate
            if (props.applyTransactionAsyncRealtime) {
                props.applyTransactionAsyncRealtime({ instrument: _instrument }, props.idTablePb)
            }
            prevStateInstrumentsDynamic.current = instrument;
            return () => { }
        }
    }, [find(instrumentsDynamic, (e) => e.SB == props?.symbol)])
    return <></>
}
export default RenderGridCellRealTimePriceBoard;
